window.cookieconsent.initialise({
  container: document.getElementById("cookieDialog"),
  content: {
    header: 'Cookies used on the website!',
    message: 'We are using cookies. By browsing our site you accept our',
    dismiss: 'Accept',
    allow: 'Allow cookies',
    deny: 'Decline',
    link: 'privacy policy',
    href: '/privacy',
    close: '&#x274c;',
  },
  cookie: {
    expiryDays: 365
  },
  // The library's own templates label the controls "learn more about
  // cookies" and "dismiss cookie message", which is not what they say on
  // screen; screen readers want the visible text.
  elements: {
    messagelink: '<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="{{link}}" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a></span>',
    link: '<a aria-label="{{link}}" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a>',
    dismiss: '<a aria-label="{{dismiss}}" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',
    allow: '<a aria-label="{{allow}}" role=button tabindex="0" class="cc-btn cc-allow">{{allow}}</a>',
    deny: '<a aria-label="{{deny}}" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',
    close: '<span aria-label="Close" role=button tabindex="0" class="cc-close">{{close}}</span>',
  },
  position: 'bottom'
});

//$(".cc-banner").wrapInner("<div class='cc-container container'></div>");
